// Exact paths only: `/privacy` must not use prefix `/privacy` or it would match `/privacy-policy`.
const exemptExactPaths = new Set([
  "/",
  "/privacy",
  "/privacy-policy",
  "/terms",
  "/imprint",
  "/for-creators",
  "/pricing",
]);

const exemptPathPrefixes = ["/login", "/logout", "/auth"];

export function isLegalGateExemptPath(pathname: string): boolean {
  if (exemptExactPaths.has(pathname)) {
    return true;
  }
  return exemptPathPrefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
